module.exports = __webpack_public_path__ + "img/落地式交流充电桩.6f00267f.png";